// ...existing imports...
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* ...existing header... */}
      <main className="flex-1">
        <Outlet />
      </main>
      {/* ...existing footer... */}
    </div>
  );
}
